import * as actions from '../../actions/bookingActions'
import { urlParams } from '../../utils/mainUtils'
import { handleError, handleResponse, securedFetch } from '../apiUtils'
import * as urls from '../urls'

/**
 * @param {Object} params - List of path params
 * @param {number[]} params.organizationIds - Organization Ids
 */
export const bookingPushYearPrices = params => (dispatch, getState) => {
    const { auth } = getState()

    dispatch(actions.b_pushYearPricesRequest())

    securedFetch(urlParams(urls.bookingPushYearPrices, params), auth, { method: 'GET' })
        .then(handleResponse)
        .then(() => dispatch(actions.b_pushYearPricesSuccess()))
        .catch(
            handleError(
                dispatch,
                actions.b_pushYearPricesFailure,
                'Что-то пошло не так!',
                'При отправке цен в Booking.com произошла ошибка'
            )
        )
}

/**
 * @param {Object} params - List of path params
 * @param {number[]} params.organizationIds - Organization Ids
 */
export const bookingPushYearRestrictions = params => (dispatch, getState) => {
    const { auth } = getState()

    dispatch(actions.b_pushYearRestrictionsRequest())

    securedFetch(urlParams(urls.bookingPushYearRestrictions, params), auth, { method: 'GET' })
        .then(handleResponse)
        .then(() => dispatch(actions.b_pushYearRestrictionsSuccess()))
        .catch(
            handleError(
                dispatch,
                actions.b_pushYearRestrictionsFailure,
                'Что-то пошло не так!',
                'При отправке ограничений в Booking.com произошла ошибка'
            )
        )
}

/**
 * @param {Object} params - List of path params (params are optional)
 * @param {number} params.organizationId - Organization Id
 */
export const bookingInventoryAvailability = params => (dispatch, getState) => {
    const { auth } = getState()

    dispatch(actions.b_inventoryAvailabilityRequest())

    securedFetch(urlParams(urls.bookingInventoryAvailability, params), auth, { method: 'GET' })
        .then(handleResponse)
        .then(() => dispatch(actions.b_inventoryAvailabilitySuccess()))
        .catch(
            handleError(
                dispatch,
                actions.b_inventoryAvailabilityFailure,
                'Что-то пошло не так!',
                'При попытке inventory доступности в Booking.com произошла ошибка'
            )
        )
}

/**
 * @param {Object} params - List of path params (params are optional)
 * @param {number} params.organizationId - Organization Id
 */
export const bookingInventoryOrder = params => (dispatch, getState) => {
    const { auth } = getState()

    dispatch(actions.b_inventoryOrderRequest())

    securedFetch(urlParams(urls.bookingInventoryOrder, params), auth, { method: 'GET' })
        .then(handleResponse)
        .then(() => dispatch(actions.b_inventoryOrderSuccess()))
        .catch(
            handleError(
                dispatch,
                actions.b_inventoryOrderFailure,
                'Что-то пошло не так!',
                'При попытке inventory заказов Booking.com произошла ошибка'
            )
        )
}

/**
 * @param {Object} params - List of path params
 * @param {number} params.organizationId - Organization Id
 */
export const bookingOtelmsInventory = params => (dispatch, getState) => {
    const { auth } = getState()

    dispatch(actions.b_otelmsInventoryRequest())

    securedFetch(urlParams(urls.bookingOtelmsInventory, params), auth, { method: 'GET' })
        .then(handleResponse)
        .then(() => dispatch(actions.b_otelmsInventorySuccess()))
        .catch(
            handleError(
                dispatch,
                actions.b_otelmsInventoryFailure,
                'Что-то пошло не так!',
                'При попытке inventory доступности в Booking.com произошла ошибка'
            )
        )
}

/**
 * @param {Object} params - List of path params
 * @param {number} params.organizationId - Organization Id
 */
export const bookingLoadBasedOnReservationSummary = params => (dispatch, getState) => {
    const { auth } = getState()

    dispatch(actions.b_loadBasedOnReservationSummaryRequest())

    securedFetch(urlParams(urls.bookingLoadBasedOnReservationSummary, params), auth, { method: 'GET' })
        .then(handleResponse)
        .then(() => dispatch(actions.b_loadBasedOnReservationSummarySuccess()))
        .catch(
            handleError(
                dispatch,
                actions.b_loadBasedOnReservationSummaryFailure,
                'Что-то пошло не так!',
                'При попытке создать заказы на основании Summary произошла ошибка'
            )
        )
}



// WEBPACK FOOTER //
// ./src/api/bookingApi/bookingSync.js